import { render } from "./listForClient.vue?vue&type=template&id=03d6937b&ts=true"
import script from "./listForClient.vue?vue&type=script&lang=ts&config=true"
export * from "./listForClient.vue?vue&type=script&lang=ts&config=true"

import "./listForClient.vue?vue&type=style&index=0&id=03d6937b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__